/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable fp/no-mutation */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import merge from 'lodash.merge';
import { commonMessages } from '../messages/common';
import { comparisonTableHeroMessages } from '../messages/comparison-table-hero';
export const ComparisonTableHeroTranslations = merge(undefined, commonMessages, comparisonTableHeroMessages);
